import type { MediaType } from "@/types";

export const typeLabels: Record<MediaType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const typePaths: Record<MediaType, string> = {
  movie: "/category/movie",
  tv: "/category/tv",
  variety: "/category/variety",
};